import { Container, createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import './App.css';
import publicThemeFile from './Classes/theme';
import Helmet from './Components/Helmet/Helmet';
import CookieBar, { setAnalyticsConsent } from './Components/Legal/CookieBar';
import ScrollUpComp from './Components/ScrollUpComp';
import { Outlet } from 'react-router-dom';
import ErrorHandle from './Components/Error/ErrorHandle';
import { useEffect, useMemo } from "react";
import BaseFooter from "./Components/Footer/BaseFooter";


export const theme = createTheme(publicThemeFile());

function App() {

  useEffect(() => {
    setAnalyticsConsent();
  }, [])

  const OutletContainer = ({ admin = false }) => {
    return (
      <Helmet>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <CookieBar />
          <div
            className="App"
            style={{
              backgroundColor: "#FBFBFB", height: "100%",
              position: "relative", overflowX: 'hidden',
              minWidth: '380px'
            }}
          >

            <ScrollUpComp />
            <div style={{ minHeight: "100vh" }}>
              <Outlet />
            </div>
            <BaseFooter />
          </div>
        </ThemeProvider>
      </Helmet>
    );
  };

  const AppBase = () => {
    return (<OutletContainer />);
  }

  return useMemo(() => (
    <ErrorHandle>
      <AppBase />
    </ErrorHandle>
  ));
}

export default App;
